// extracted by mini-css-extract-plugin
export default {"prefixAllowance":"prefixAllowance__17Dtb"};